import React from 'react';
import { Tag } from '@pushpay/tag';

type TagDisplayStyle = 
  | 'default'
  | 'success'
  | 'info'
  | 'info.orange'
  | 'warning'
  | 'error';

interface StatusTagProps {
  label: string;
  variant?: 'default' | 'success' | 'warning' | 'info' | 'error' | 'info-orange';
  dataTarget?: string;
}

const variantMap: Record<string, TagDisplayStyle> = {
  'default': 'default',
  'success': 'success',
  'warning': 'warning',
  'info': 'info',
  'error': 'error',
  'info-orange': 'info.orange',
};

export const StatusTag: React.FC<StatusTagProps> = ({
  label,
  variant = 'default',
  dataTarget,
}) => {
  return (
    <Tag
      displayStyle={variantMap[variant]}
      label={label}
      data-pp-at-target={dataTarget}
    />
  );
};
